import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { modalTypes } from "constants/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { selectGitCommit, selectProductVersion } from "slices/app/selectors";

const AboutVtDocsModal = () => {
  const dispatch = useDispatch();
  const buildNumber = useSelector(selectGitCommit);
  const productVersion = useSelector(selectProductVersion);
  const currentYear = new Date().getFullYear();

  const handleClose = () => {
    dispatch(hideModal(modalTypes.ABOUT_VT_DOCS));
  };

  const textBoxContent = () => (
    <>
      VisibleThread(tm) On-demand/On-premise
      <br />
      <br />
      Copyright (c) 2011 VisibleThread Ltd. All rights reserved.
      <br />
      <br />
      This product includes software developed by CollabNet
      (http://www.Collab.Net/).
      <br />
      <br />
      Copyright (c) 2000-2011 CollabNet. All rights reserved.
      <br />
      <br />
      Redistribution and use in source and binary forms, with or without
      modification, are permitted provided that the following conditions are
      met:
      <br />
      <br />
      1. Redistributions of source code must retain the above copyright notice,
      this list of conditions and the following disclaimer.
      <br />
      2. Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.
      <br />
      3. The end-user documentation included with the redistribution, if any,
      must include the following acknowledgment: &rsquo;This product includes
      software developed by CollabNet (http://www.Collab.Net/).&rsquo;
      Alternately, this acknowledgment may appear in the software itself, if and
      wherever such third-party acknowledgments normally appear.
      <br />
      4. The hosted project names must not be used to endorse or promote
      products derived from this software without prior written permission. For
      written permission, please contact info@collab.net.
      <br />
      5. Products derived from this software may not use the
      &rsquo;Tigris&rsquo; name nor may &rsquo;Tigris&rsquo; appear in their
      names without prior written permission of CollabNet.
      <br />
      <br />
      THIS SOFTWARE IS PROVIDED &rsquo;AS IS&rsquo; AND ANY EXPRESSED OR IMPLIED
      WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
      MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.IN NO
      EVENT SHALL COLLABNET OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
      (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
      SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
      CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
      LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
      OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
      SUCH DAMAGE.
      <br />
      <br />
      This software consists of voluntary contributions made by many individuals
      on behalf of CollabNet.
      <br />
      <br />
      The Software contains other software distributed under the GNU General
      Public License Version 2, June 1991; for three years from the date of
      grant of this license, you may request a complete machine-readable copy of
      the source code that corresponds to that software. VisibleThread Ltd
      reserves the right to charge you the cost of physically performing such
      source code distribution including the cost of administration,
      reproduction, post and packaging; alternatively, you may care to access
      the software at http://www.gnu.org/ <br />
      <br />
      COPYRIGHT NOTICE AND DISCLAIMER
      <br />
      <br />
      The following applies to all software licensed under the GNU General
      Public License Version 2, June 1991 including the software in
      VisibleThread(tm) Dashboard.
      <br />
      <br />
      Copyright (c) 1989, 1991 Free Software Foundation, Inc. 675 Mass Ave,
      Cambridge, MA 02139, USA. Everyone is permitted to copy and distribute
      verbatim copies of this license document, but changing it is not allowed.
      <br />
      <br />
      Everyone is permitted to copy and distribute verbatim copies of this
      license document, but changing it is not allowed.
      <br />
      <br />
      NO WARRANTY <br />
      BECAUSE THE PROGRAM IS LICENSED UNDER THE GNU GENERAL PUBLIC LICENSE FREE
      OF CHARGE, THERE IS NO WARRANTY FOR THE PROGRAM, TO THE EXTENT PERMITTED
      BY APPLICABLE LAW. EXCEPT WHEN OTHERWISE STATED IN WRITING THE COPYRIGHT
      HOLDERS AND/OR OTHER PARTIES PROVIDE THE PROGRAM &rsquo;AS IS&rsquo;
      WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT
      NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
      A PARTICULAR PURPOSE. THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF
      THE PROGRAM IS WITH YOU. SHOULD THE PROGRAM PROVE DEFECTIVE, YOU ASSUME
      THE COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION. <br />
      <br />
      IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED TO IN WRITING WILL
      ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO MAY MODIFY AND/OR
      REDISTRIBUTETHE PROGRAM AS PERMITTED ABOVE, BE LIABLE TO YOU FOR DAMAGES,
      INCLUDING ANY GENERAL, SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES
      ARISING OUT OF THE USE OR INABILITY TO USE THE PROGRAM (INCLUDING BUT NOT
      LIMITED TO LOSS OF DATA OR DATA BEING RENDERED INACCURATE OR LOSSES
      SUSTAINED BY YOU OR THIRD PARTIES OR A FAILURE OF THE PROGRAM TO OPERATE
      WITH ANY OTHER PROGRAMS), EVEN IF SUCH HOLDER OR OTHER PARTY HAS BEEN
      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      <br />
      <br />
      SUN, SOLARIS, JAVA, JINI, FORTE, STAROFFICE, STARPORTAL and iPLANET
      trademarks and logos are trademarks or registered trademarks of Sun
      Microsystems, Inc. in the United States and other countries. <br />
      Java and all Java-based trademarks and logos are trademarks or registered
      trademarks of Sun Microsystems, Inc. in the U.S. or other countries, and
      are used under license.
      <br />
      <br />
      All titles and copyrights in and to the Java(c) Project X Technology are
      owned and licensed by Sun Microsystems, Inc. Copyright (c) Sun
      Microsystems, Inc. All rights reserved.
      <br />
      <br />
      This product includes software developed by the Apache Software Foundation
      (http://www.apache.org/).
      <br />
      <br />
      Copyright (c)1999-2000 The Apache Software Foundation. All rights
      reserved. Redistribution and use in source and binary forms, with or
      without modification, are permitted provided that the following conditions
      are met:
      <br />
      1. Redistributions of source code must retain the above copyright notice,
      this list of conditions and the following disclaimer.
      <br />
      2. Redistributions in binary form must reproduce the above copyright
      notice,this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.
      <br />
      3. The end-user documentation included with the redistribution, if any,
      must include the following acknowledgment: &rsquo;This product includes
      software developed by the Apache Software Foundation
      (http://www.apache.org/).&rsquo; Alternately, this acknowledgment may
      appear in the software itself, if and wherever such third-party
      acknowledgments normally appear. <br />
      4. The names &rsquo;Xerces&rsquo; and &rsquo;Apache Software
      Foundation&rsquo; must not be used to endorse or promote products derived
      from this software without prior written permission. For written
      permission, please contact apache@apache.org. <br />
      5. Products derived from this software may not be called
      &rsquo;Apache&rsquo;, nor may &rsquo;Apache&rsquo; appear in their name,
      without prior written permission of the Apache Software Foundation. <br />
      <br />
      THIS SOFTWARE IS PROVIDED &rsquo;AS IS&rsquo; AND ANY EXPRESSED OR IMPLIED
      WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
      MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO
      EVENT SHALL THE APACHE SOFTWARE FOUNDATION OR ITS CONTRIBUTORS BE LIABLE
      FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
      DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
      SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
      CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
      LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
      OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
      SUCH DAMAGE.
      <br />
    </>
  );

  return (
    <Modal className="fade-in" show onDismiss={handleClose} backdrop centered>
      <Modal.Header>About VisibleThread</Modal.Header>
      <Modal.Body>
        <div className="about__modal__body">
          <Flex style={{ marginBottom: 16 }} gap={GAP_CLASS.GAP_200}>
            <div>VisibleThread™</div>
            <a
              href="https://support.visiblethread.com/hc/en-us/requests/new"
              target="_blank"
              alt="VisibleThread Help"
              rel="noreferrer"
            >
              help
            </a>
          </Flex>

          <p data-testid="productAndBuildNumber">
            Version: {productVersion} - Build {buildNumber}
          </p>
          <p>Copyright © {currentYear} VisibleThread</p>
          <div className="about__modal__body__text_box">{textBoxContent()}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="closeButton"
          variant={NewButtonVariant.l1}
          onClick={handleClose}
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutVtDocsModal;
